import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../services/auth.service';
import salePointsConfig from '../table/configs/sale-points.json';
import salePointsInactiveConfig from '../table/configs/sale-points-inactive.json';
import {TableConfig} from '../table/table-config';
import {TableComponent} from '../table/table.component';

@Component({
  templateUrl: './sale-point.component.html'
})
export class SalePointComponent implements OnInit {
  // @ViewChild('tableContainer') tableContainer: TableComponent;

  public user: any;
  public salePointsConfig: TableConfig;
  public salePointsInactiveConfig: TableConfig;

  constructor(private authService: AuthService) {
    this.salePointsConfig = salePointsConfig;
    this.salePointsInactiveConfig = salePointsInactiveConfig;
  }



  public async ngOnInit(): Promise<any> {
    this.user = await this.authService.getUser();
  }
}
